export default __webpack_public_path__ + "static/media/Android_Studio_icon.11701c9d.svg";